export interface IApiActiveUsersCount {
  Total?: number;
  Favorites?: number;
  Friends?: number;
}

export default class DateFinderCount {
  total: number;
  favorites: number;
  friends: number;

  constructor() {
    this.total = 0;
    this.favorites = 0;
    this.friends = 0;
  }

  static mappingPropertyObject(object: IApiActiveUsersCount): DateFinderCount {
    // Note: The original file was activeUsersCount.js but the class was named DateFinderCount
    // I kept the class name as DateFinderCount to match the original
    const newObject = new DateFinderCount();
    newObject.total = object.Total || 0;
    newObject.favorites = object.Favorites || 0;
    newObject.friends = object.Friends || 0;
    return newObject;
  }
}
